import React from 'react'
import { ForEachModel, useValue, ValueToCollection } from '@morningtrain/react-resources'
import CalendarWeeks from 'pages/app/vacation/partials/CalendarWeeks'
import BackgroundDays from 'pages/app/vacation/BackgroundDays'
import Entry from 'pages/app/vacation/Entry'
import moment from 'moment'
import EmployeesCalendarColumnInner from 'pages/app/vacation/partials/EmployeesCalendarColumnInner'
import CalendarEntries from 'pages/app/vacation/partials/CalendarEntries'

export default function Calendar () {
  const period = useValue('period')

  const blocks = React.createRef()
  const weeksInner = React.createRef()
  const employeesInner = React.createRef()
  const employeesViewport = React.createRef()
  const blocksInner = React.createRef()
  const backgroundDays = React.createRef()

  const filterValue = {
    from: period && period.from ? moment(period.from) : moment().startOf('isoWeek'),
    to: period && period.to ? moment(period.to) : moment().add(1, 'year')
  }

  const currentDay = moment(filterValue.from).startOf('isoWeek')
  const to = moment(filterValue.to).endOf('isoWeek')

  const width = (1 + to.diff(currentDay, 'days')) * 30

  const onScroll = () => {
    weeksInner.current.style.transform = `translateX(${-blocks.current.scrollLeft}px)`
    employeesInner.current.style.transform = `translateY(${-blocks.current.scrollTop}px)`
  }

  return (
    <>
      <div className='crud-index-calendar'>
        <div className='flex'>
          <div className='employees'>
            <div className='employees-viewport' ref={employeesViewport}>
              <div className='employees-inner' ref={employeesInner}>
                <ForEachModel>
                  <ValueToCollection name='collection'>
                    <EmployeesCalendarColumnInner />
                  </ValueToCollection>
                </ForEachModel>
              </div>
            </div>
          </div>
          <div className='calendar'>
            <div className='weeks'>
              <div className='weeks-inner' ref={weeksInner}>
                <CalendarWeeks />
              </div>
            </div>
            <div className='blocks' onScroll={onScroll} ref={blocks}>
              <div className='blocks-inner' ref={blocksInner} style={{ width: width }}>
                <div className='background-days' ref={backgroundDays} style={{ width: width }}>
                  <BackgroundDays />
                </div>
                <CalendarEntries />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
